import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Notifications from "../helpers/toast-notifications";
import i18n from "../i18n";
import tablesStore from "./tablesStore";
import mainViewsStore from "./modules/mainViews/mainViewsStore";
import buffetMainViewStore from "./modules/buffet/buffetMainViewStore";
import gradeEduclassShared from "./modules/mainViews/grade-educationClass-shared/store";
import studentStore from "./modules/students/studentStore";
import parents from "./modules/users/parents";
import admins from "./modules/users/admins";
import teachersStore from "./modules/teachers/teachersStore";
import cashierFinancialOrder from "./modules/financial-order/cashierFinancialOrder";
import accountantFinancialOrder from "./modules/financial-order/accountantFinancialOrder";
import costCenter from "./modules/costCenter";
import cashierBox from "./modules/cashierBox";
import router from "../router";
import timeAttendance from "@/store/modules/HR/time_attendence";
import employees from "@/store/modules/HR/employees";
import calculations from "@/store/modules/HR/calculations";
import loans from "@/store/modules/HR/loans";
import payments from "@/store/modules/HR/payments";
import vacations from "@/store/modules/HR/vacations";
import variations from "@/store/modules/HR/variations";
import payinstallment from "@/store/modules/pay-installments/payinstallment";
import restrictions from "@/store/modules/restrictions";

Vue.use(Vuex);
// online serveer domain
// https://bahlol-demo-back.point-dev.net
// https://bahlol-back.point-dev.net/api
// https://bahlol-back.incentive-dev.com
// https://incentive-dev.com
// http://192.168.1.5:8080
// https://back-demo.incentive-dev.com
// http://127.0.0.1:8080
// https://platform-back.incentive-dev.com

export default new Vuex.Store({
  state: {
    serverDomain: "https://platform-back.incentive-dev.com/api",
    barImage: "",
    drawer: null,
    userData: {
      username: "",
      abilities: [],
    },
    routeNameAddition: "",
    isDarkMode: false,
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      console.log("in set drawer?");
      state.drawer = payload;
    },
    setUserData(state, userInfo) {
      state.userData.username = userInfo.user_name;
      state.userData.abilities = userInfo.ability;
    },
    setRouteNameAddition(state, addition) {
      state.routeNameAddition = addition;
    },
    SET_DARK_MODE(state, payload) {
      state.isDarkMode = payload;
    },
  },
  actions: {
    async userLogin({ commit }, userData) {
      try {
        axios.defaults.headers.common["term"] = userData.termId;
        localStorage.setItem("nawader_term", userData.termId);

        const logInResponse = await axios.post("/auth/login", {
          username: userData.username,
          password: userData.password,
        });

        console.log("login response", logInResponse);
        commit("setUserData", logInResponse.data.data);
        localStorage.setItem(
          "nawader_user_data",
          JSON.stringify(logInResponse.data.data)
        );
        localStorage.setItem(
          "nawader_access_token",
          logInResponse.data.data.access_token
        );
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + logInResponse.data.data.access_token;
        Notifications(
          i18n.t("login success"),
          { timeout: 1000, rtl: true },
          "success"
        );
        router.push("/");
      } catch (err) {
      } finally {
      }
    },
    autoLogIn({ commit }) {
      commit(
        "setUserData",
        JSON.parse(localStorage.getItem("nawader_user_data"))
      );
      axios.defaults.headers.common["term"] =
        localStorage.getItem("nawader_term");
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("nawader_access_token");
    },
  },
  getters: {
    getUserName(state) {
      return state.userData.username;
    },
    getUserAbilities(state) {
      return state.userData.abilities;
    },
    getRouteNameAddition(state) {
      return state.routeNameAddition;
    },
  },
  modules: {
    tablesStore,
    ...mainViewsStore,
    ...buffetMainViewStore,
    ...studentStore,
    ...teachersStore,
    ...gradeEduclassShared,
    costCenter,
    cashierBox,
    parents,
    admins,
    cashierFinancialOrder,
    accountantFinancialOrder,
    timeAttendance,
    employees,
    calculations,
    loans,
    payments,
    vacations,
    variations,
    payinstallment,
    restrictions,
  },
});
